import React from 'react';
import { Form, Select } from 'antd';

const { Option } = Select;

/**
 * Reusable Select Field Component
 * Can be used across all modules for dropdown selections
 * 
 * @param {string} name - Field name
 * @param {string} label - Field label
 * @param {string} placeholder - Placeholder text
 * @param {Array} options - Array of options {value, label} or {id, name}
 * @param {boolean} required - Whether field is required
 * @param {boolean} readOnly - Whether field is read-only
 * @param {boolean} loading - Loading state
 * @param {boolean} allowClear - Allow clearing selection
 * @param {boolean} showSearch - Enable search functionality
 * @param {Array} rules - Additional validation rules
 * @param {function} onSearch - Search handler
 * @param {function} onSelect - Selection handler
 * @param {object} ...props - Additional props passed to Select component
 */
const SelectField = ({ 
  name, 
  label, 
  placeholder, 
  options = [], 
  required = false, 
  readOnly = false,
  loading = false,
  allowClear = true,
  showSearch = false,
  rules = [],
  onSearch,
  onSelect,
  ...props 
}) => (
  <Form.Item
    name={name}
    label={label}
    rules={required ? [{ required: true, message: `Please select ${label.toLowerCase()}` }, ...rules] : rules}
  >
    <Select 
      placeholder={placeholder}
      size="large"
      className="w-full rounded-lg"
      loading={loading}
      disabled={readOnly}
      allowClear={allowClear}
      showSearch={showSearch}
      onSearch={onSearch}
      onSelect={onSelect}
      filterOption={(input, option) =>
        option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      style={readOnly ? { cursor: 'not-allowed', backgroundColor: '#f9fafb' } : { backgroundColor: '#f9fafb' }}
      {...props}
    >
      {options.map(option => (
        <Option key={option.value || option.id} value={option.value || option.id}>
          {option.label || option.name}
        </Option>
      ))}
    </Select>
  </Form.Item>
);

export default SelectField;
